import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
// Entities
import { Detail, Company } from "@/entities/index";

@Component
export default class OrderDetail extends Vue {
  client = this.company.codeLogistic;
  @Prop() readonly reference!: string;

  @Watch("reference")
  onReferenceChange(value: string, oldValue: string) {
    this.loadOrderDetail();
  }

  orderDetail: Detail[] = [];
  orderDetailCSV: Detail[] = [];

  headers = [
    {
      text: this.$t("OrderDetail.table.reference"),
      class: "indigo--text text--darken-4",
      align: "start",
      value: "reference",
    },
    {
      text: this.$t("OrderDetail.table.libelle"),
      class: "indigo--text text--darken-4",
      value: "libelle",
    },
    {
      text: this.$t("OrderDetail.table.ordered"),
      class: "indigo--text text--darken-4",
      value: "ordered",
    },
    {
      text: this.$t("OrderDetail.table.shipped"),
      class: "indigo--text text--darken-4",
      value: "shipped",
    },
  ];

  headersCSV = [
    {
      text: "Reference",
      value: "reference",
    },
    { text: "Libelle", value: "libelle" },
    { text: "Quantite commandee", value: "ordered" },
    { text: "Quantite expediee", value: "shipped" },
  ];

  async loadOrderDetail(): Promise<void> {
    this.orderDetail = (
      await axios.post(`/api/orders/details`, {
        client: this.client,
        reference: this.reference,
      })
    ).data as Detail[];
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Consultation du détail d'une commande",
    });
  }

  // ========== GETTERS ========== //

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile() {
    return this.$store.getters.profile;
  }

  // ========== OTHERS METHODS ========== //

  colorRow(item: Detail): any {
    const position = this.orderDetail.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  // === EXPORT TO CSV === //

  async detailCSV(): Promise<Detail[]> {
    const response = await axios.post(`/api/orders/details`, {
      client: this.client,
      reference: this.reference,
    });
    const orderDetailCSV = response.data as Detail[];
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Extraction du détail d'une commande en CSV",
    });
    return orderDetailCSV;
  }

  convertToCSV(json: any): string {
    if (json.libelle === null || json.libelle === undefined) {
      json.libelle = "";
    }
    if (json.reference === null || json.reference === undefined) {
      json.reference = "";
    }
    if (json.ordered === null || json.ordered === undefined) {
      json.ordered = "";
    }
    if (json.shipped === null || json.shipped === undefined) {
      json.shipped = "";
    }
    json.libelle = json.libelle.replace(/ /g, "");
    return `"${json.reference}";"${json.libelle}";"${json.ordered}";"${json.shipped}"`;
  }

  async downloadCSV(): Promise<void> {
    const orderDetail = await this.detailCSV();
    const csvJSON = this.orderDetail.map((json: any) =>
      this.convertToCSV(json)
    );
    csvJSON.unshift(
      this.headersCSV.map((header: any) => header.text).join(";")
    );
    const csvData = csvJSON.join("\n");
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "Detail.csv";
    link.click();
  }

  async mounted(): Promise<void> {
    this.loadOrderDetail();
  }
}
